<template>
  <v-container fluid>
    <!-- <base-page-title title="Dashboard Inicial"></base-page-title> -->
    <div class="red--text ">
      <v-col>
        <v-container class="">
          <v-img class="ma-7 mb-0" contain max-height="45vh" :src="erro_404">
          </v-img>
          <div class="pa-3 headline primary--text text-center" > 
            <div class="mb-10 mt-n3 font-weight-bold">
            Uh-oh! Essa página não foi encontrada
            </div>
            <v-btn class="mt-10" color="error" small @click="$router.push('/')" rounded><v-icon left>mdi-arrow-left</v-icon>voltar</v-btn>
          </div>
          <div class="mb-10 mt-15 font-weight-normal text-center primary--text">
            Se você acha que está vendo isso por engano, entre em contato com nosso time de suporte em 
            <a href="mailto:contato@azoplataforma.com.br" class="font-weight-bold gtxt"> contato@azoplataforma.com.br </a>
          </div>
        </v-container>
      </v-col>
  </div>
  </v-container>
</template>

<script>
// @ is an alias to /src
import { mapState } from 'vuex'
import logoErr from "@/assets/err404.png";

export default {
  name: 'Home',
  data() {
    return {
      key: null,
      erro_404: logoErr

    }
  },
  components: {
    BaseHome: () => import('../components/homepage/BaseHome'),
  },
  computed: {
    // profile_roles(){
    //   if(this.profile?.employee?.role) return true
    //   return false
    // },
    ...mapState({
      // profile: state=>state.User.oneUser,
      // data: state=> state.Module.state_var
    })
  },
}
</script>
